import React, {Fragment} from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'
import Banner from '../../assets/senior_banner.svg'
import BlueTick from '../../assets/blue_tick.svg'
import { pushToDataLayer, logEvent } from '../Analytics'

class Hero extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
    const {headerBackBlue, headerMobileBackBlue} = this.props.query;
            return(
                <Fragment>
                    <section className="barns-bannet1 junior-banner" style={{background: `url(${headerBackBlue.publicURL})`}}>
                        <div className="custom-container">
                            <div className="content-img">
                                <div className="col-lg-6 col-sm-6 col-md-6 col-xs-12" style={{margin: '3rem 0 0 0'}}>
                                    <div className="row">
                                    <div className="form-sec">
                                        <h1 style={{fontFamily: 'bariol-bold'}}>En värdefull kunskapsresa <br/> för de yngsta</h1>	
                                        <p className="desktop">Albert hjälper barn att lära sig matematik på ett roligt och effektivt sätt. <br/>Pedagogiska uppgifter och interaktiva övningar blandas med positiv <br/>feedback för att skapa bättre lärupplevelser.</p>
                                        <p className="for-mobile">Albert hjälper barn att lära sig matematik på ett roligt  <br/> och effektivt sätt. Pedagogiska uppgifter och  <br/> interaktiva övningar blandas med positiv feedback för <br/> att skapa bättre lärupplevelser.</p>
                                        <div className="btn-sec">
                                            <Link to="/register" className="prova" onClick={e => {
                                                logEvent(
                                                `Junior page Prova gratis i 30 dagar button`,
                                                `Junior page Prova gratis i 30 dagar button was clicked`
                                                )
                                                pushToDataLayer(
                                                    'userClick',
                                                    'Junior Page Prova Gratis I 30 Dagar Button',
                                                    'Junior Page Prova Gratis I 30 Dagar Button Was Clicked'
                                                )
                                                }}>PROVA GRATIS NU <span className="line">Ordinarie pris 99 kr/mån</span></Link>
                                            {/* <p style={{ margin: '1rem 0 0 0', textAlign: 'left', maxWidth: '16rem', color: '#000', fontSize: '0.8rem' }}>* 9 Januari 2020</p> */}
                                        </div>

                                    </div>
                                </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-md-6 col-xs-12">
                                    <div className="row">
                                    </div>
                                </div>
                            </div>
                            </div>
                             {/* <figure className="for-mobile"><img src={headerMobileBackBlue.publicURL}/></figure> */}
                    </section>
                </Fragment>
            )
        
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    headerBackBlue: file(relativePath: {regex: "/junior-banner/"}) {
                        publicURL
                    }
                    headerMobileBackBlue: file(relativePath: {regex: "/junior-mobile-banner-wave/"}) {
                        publicURL
                    }
                }`
            }
        render={(data)  => (
           <Hero query={data} {...props}/>
        )}
    />
)